import { render, staticRenderFns } from "./thirdParty.vue?vue&type=template&id=cc2471bc&scoped=true"
import script from "./thirdParty.vue?vue&type=script&lang=js"
export * from "./thirdParty.vue?vue&type=script&lang=js"
import style0 from "./thirdParty.vue?vue&type=style&index=0&id=cc2471bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2471bc",
  null
  
)

export default component.exports